function getBrandIdentifier(route) {
  return { brandIdentifier: Number(route.query.brandIdentifier) };
}

export default [
  {
    name: 'surveyManagement',
    path: '/survey_management',
    meta: {
      title: '설문 조사 관리',
      requiresBrandKey: true
    },
    component: () => import(/* webpackChunkName: "SurveyManagement" */ '@/views/workplace/brand/survey/SurveyManagement'), // 설정 -> 설문조사 관리 -> 설문조사 진행상태 -> 설문조사 관리
    props: getBrandIdentifier
  }
];



// WEBPACK FOOTER //
// ./src/router/subRoutes/survey.js